import type { ReactElement } from 'react';

import { FolderIcon } from '@bestseller-bit/frontend-community.theme.buying-theme';
import Stack from '@mui/material/Stack';
import { alpha, useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface CollectionNameHeaderProps {
    /** The collection name to display */
    collectionName?: string;
}

const CollectionNameHeader = ({
    collectionName,
}: CollectionNameHeaderProps): ReactElement => {
    const { palette } = useTheme();

    return (
        <Stack
            direction="row"
            spacing={2}
            sx={{
                alignItems: 'center',
            }}
        >
            <FolderIcon
                size={20}
                style={{ flexShrink: 0 }} // Keep the icon from shrinking next to long names
                color={alpha(palette.primary.main, 0.5)}
            />

            <Typography variant="captions.highlight">
                {collectionName ?? 'Missing Collection Name'}
            </Typography>
        </Stack>
    );
};

export { CollectionNameHeader };
